import template from './active_promo.html';
import controller from './active_promo.controller';

const activePromoMessageComponent = {
  restrict: 'E',
  controller,
  template
};

export default activePromoMessageComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/messageOutbound/active_promo/active_promo.component.js
 **/